export default function getTopLevelSegment(pathname: string): string {
  return pathname.split('/')[1] ?? '';
}
